import { usePageMeta } from "@/hooks/usePageMeta";
import { Reveal } from "@/components/Reveal";

const Block = ({ title, children }) => (
  <Reveal>
    <div className="border-t border-hairline py-8 md:py-10">
      <h2 className="font-serif text-2xl md:text-3xl tracking-tight">{title}</h2>
      <div className="mt-4 text-soot text-[15px] md:text-base leading-relaxed space-y-3">{children}</div>
    </div>
  </Reveal>
);

export default function PolitiqueConfidentialite() {
  usePageMeta(
    "Politique de confidentialité — Les Mots pour le Dire",
    "Politique de confidentialité du site Les Mots pour le Dire : données collectées, finalité, conservation et vos droits."
  );

  return (
    <div className="pt-36 md:pt-44 pb-24" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-6">
        <Reveal>
          <p className="eyebrow">Vos données</p>
        </Reveal>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] mt-5">
          Politique de confidentialité
        </h1>

        <div className="mt-12" data-testid="legal-confidentialite-section">
          <Block title="Données collectées">
            <p>
              Les formulaires du site (formulaire de contact et questionnaire) collectent votre nom,
              votre prénom, votre adresse e-mail, votre numéro de téléphone (facultatif) ainsi que le
              contenu de votre demande.
            </p>
          </Block>

          <Block title="Finalité du traitement">
            <p>
              Ces données servent uniquement à répondre à votre demande et, si vous le souhaitez, à
              établir un devis. Chaque demande est lue et traitée personnellement.
            </p>
          </Block>

          <Block title="Destinataire">
            <p>
              Vos demandes sont transmises à Carole Bourbasquet uniquement. Vos écrits restent
              confidentiels et ne sont jamais transmis à des tiers.
            </p>
          </Block>

          <Block title="Durée de conservation">
            <p>
              Les demandes sont conservées le temps nécessaire au traitement de votre projet, puis
              supprimées.
            </p>
          </Block>

          <Block title="Vos droits">
            <p>
              Vous disposez d'un droit d'accès, de rectification et d'effacement de vos données. Pour
              l'exercer, écrivez à{" "}
              <a href="mailto:contact@lesmots-pourledire.fr" className="link-underline !text-[15px]" data-testid="legal-rgpd-link">
                contact@lesmots-pourledire.fr
              </a>
              .
            </p>
          </Block>

          <Block title="Cookies">
            <p>Le site n'utilise pas de cookies publicitaires ni de traceurs.</p>
          </Block>
        </div>
      </div>
    </div>
  );
}
